import { useCallback, useRef } from "react";
import { api } from "../lib/api";

function getSessionId() {
  let id = sessionStorage.getItem("ng_session_id");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("ng_session_id", id);
  }
  return id;
}

function getVisitorId() {
  let id = localStorage.getItem("ng_visitor_id");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("ng_visitor_id", id);
  }
  return id;
}

export function hasConsent() {
  return localStorage.getItem("ng_consent") === "granted";
}

export function trackMetaPixel(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  if (!hasConsent()) return;
  window.fbq("trackCustom", eventName, params);
}

export function useAnalytics(releaseSlug) {
  const sessionIdRef = useRef(getSessionId());
  const visitorIdRef = useRef(getVisitorId());

  const track = useCallback((eventType, extra = {}) => {
    const consent = hasConsent();
    if (eventType !== "page_view" && !consent) return;
    api.post("/events", {
      release_slug: releaseSlug,
      event_type: eventType,
      session_id: sessionIdRef.current,
      visitor_id: visitorIdRef.current,
      consent,
      extra,
    }).catch(() => {});
  }, [releaseSlug]);

  return { track, sessionId: sessionIdRef.current };
}
